import { useContext } from "react";
import styled from "styled-components";
import { Context } from "../../../context";

export const FeaturesWrapper = styled("div")(() => {
  const { isMenuOpen } = useContext(Context);
  return {
    position: "relative",
    top: isMenuOpen ? "var(--mobileNavLinks)" : "0",
    margin: "calc(var(--sectionMargin) * 2) auto",
    padding: "calc(var(--pagePadding)/ 2) var(--pagePadding)",
    width: "80%",
    "@media screen and (max-width: 1024px)": {
      margin: "calc(var(--sectionMargin) * 3) auto",
      width: "75%",
    },
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  };
});

export const FeaturesContainer = styled("div")(() => {
  return {
    maxWidth: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "calc(var(--flexGap)/ 3)",
  };
});

export const BentoGrid = styled("div")(() => {
  return {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "var(--flexGap)",
    gridAutoRows: "300px",
    "@media screen and (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      gridAutoRows: "auto",
    },
  };
});

export const FeatureCard = styled("div")(({
  backgroundColor,
  textColor,
  gridPosition,
}) => {
  let gridStyles = {};

  if (gridPosition === "top-left") {
    gridStyles = {
      gridColumn: "1 / span 2",
      gridRow: "1",
      "@media screen and (max-width: 425px)": {
        gridColumn: "1",
        gridRow: "auto",
      },
    };
  } else if (gridPosition === "top-right") {
    gridStyles = {
      gridColumn: "3",
      gridRow: "1",
      "@media screen and (max-width: 425px)": {
        gridColumn: "1",
        gridRow: "auto",
      },
    };
  } else if (gridPosition === "bottom-left") {
    gridStyles = {
      gridColumn: "1",
      gridRow: "2",
      "@media screen and (max-width: 425px)": {
        gridColumn: "1",
        gridRow: "auto",
      },
    };
  } else if (gridPosition === "bottom-right") {
    gridStyles = {
      gridColumn: "2 / span 2",
      gridRow: "2",
      "@media screen and (max-width: 425px)": {
        gridColumn: "1",
        gridRow: "auto",
      },
    };
  }

  return {
    ...gridStyles,
    padding: "2rem",
    backgroundColor: backgroundColor,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
    },
    "@media screen and (max-width: 768px)": {
      gridAutoRows: "auto",
    },
  };
});

export const CardLabel = styled("span")(() => {
  return {
    fontSize: "0.75rem",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "var(--color-primary)",
    marginBottom: "0.5rem",
  };
});

export const CardIcon = styled("div")(({ textColor }) => {
  return {
    fontSize: "2rem",
    color: textColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  };
});

export const CardTitle = styled("h3")(({ textColor }) => {
  return {
    marginBlock: 0,
    fontSize: "2rem",
    fontWeight: "700",
    color: textColor,
    lineHeight: "1.3",
  };
});

export const CardDescription = styled("p")(({ textColor }) => {
  return {
    marginBlock: 0,
    fontSize: "1rem",
    color: textColor,
    lineHeight: "1.6",
    opacity: textColor === "#FFFFFF" ? 0.9 : 0.8,
  };
});
